// extracted by mini-css-extract-plugin
export var actionButton = "_ow-0";
export var actionMenuContainer = "_ow-i";
export var bubble = "_ow-2";
export var bubbleActionMenu = "_ow-j";
export var bubbleContext = "_ow-6";
export var bubbleItems = "_ow-7";
export var customer = "_ow-3";
export var divider = "_ow-8";
export var fileList = "_ow-9";
export var hiddenComment = "_ow-o";
export var infoAbove = "_ow-a";
export var internal = "_ow-4";
export var lightActionButton = "_ow-1";
export var link = "_ow-b";
export var merchant = "_ow-5";
export var message = "_ow-c";
export var profilePicture = "_ow-e";
export var quillToolbarContainer = "_ow-f";
export var senderDate = "_ow-g";
export var senderDateCustomer = "_ow-h";
export var senderName = "_ow-d";
export var time = "_ow-k";
export var uploadedImage = "_ow-l";
export var username = "_ow-m";
export var xsmall = "_ow-n";